import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=5935a611&scoped=true"
var script = {}
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=5935a611&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5935a611",
  null
  
)

export default component.exports